import { useMemo } from 'react';
import { Card } from 'react-bootstrap';

import dateFormat from 'dateformat';

import { ExportToCSVButton } from '@components/Buttons';
import { BootstrapGenericTable } from '@components/Table/Table';

export const BalanceHistoryTable = ({ useData, searchParams }) => {
  const showCalls = searchParams.get('showCalls') || 'false';
  const SHOW_ALL = '1';
  const NO_SHOW_CALLS = '2';
  const filterData = {
    show: showCalls === 'true' ? SHOW_ALL : NO_SHOW_CALLS,
  };

  const exportContent = () => (
    <ExportToCSVButton
      to="customer/balance/history/export"
      filterData={filterData}
    />
  );

  const columns = useMemo(
    () => [
      {
        Header: 'Date modified',
        accessor: 'date_modified',
        Cell: ({ value }) => {
          const date = new Date(value);
          return dateFormat(date, 'defaultDateTime');
        },
      },
      {
        Header: 'Description',
        accessor: 'description',
      },
      {
        Header: 'Value',
        accessor: 'value',
      },
      {
        Header: 'Balance',
        accessor: 'balance',
      },
      {
        id: 'call',
        accessor: 'call',
      },
    ],
    []
  );

  return (
    <Card>
      <Card.Header className="bg-didxl text-white">Balance history</Card.Header>
      <Card.Body>
        <BootstrapGenericTable
          columns={columns}
          useData={useData}
          filterData={filterData}
          tableProps={() => ({
            responsive: true,
            bordered: true,
            className: 'normalFontSize',
          })}
          paginated
          exportContent={exportContent}
          hiddenColumns="call"
        />
      </Card.Body>
    </Card>
  );
};
